/**
 * 管理后台布局组件
 *
 * 提供整体页面布局结构
 * - 侧边栏：导航菜单
 * - 头部：用户信息、登出按钮
 * - 内容区域：页面主体
 *
 * 设计说明：
 * - 背景使用微妙渐变 + 网格纹理增加视觉层次
 * - 内容区域有统一的内边距和层次感
 */
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

/* ============================================
 * 管理后台布局组件
 * ============================================ */

export default function AdminLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  // 移动端抽屉开关（md 以下侧栏收进屏幕外，由 Header 汉堡按钮唤出）
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* 背景层 - 渐变 + 网格纹理 */}
      <div className="absolute inset-0 bg-gradient-to-br from-neutral-50 via-slate-50/50 to-primary-50/20" />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(to right, hsl(var(--border)) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(var(--border)) 1px, transparent 1px)
          `,
          backgroundSize: '48px 48px',
        }}
      />

      {/* 侧边栏（桌面常驻；移动端为覆盖式抽屉，内容区不避让） */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* 主内容区域（小屏无边距，md 起按桌面侧栏宽度避让） */}
      <div
        className={`
          relative transition-all duration-300 ease-in-out
          ${sidebarCollapsed ? 'md:ml-16' : 'md:ml-64'}
        `}
      >
        {/* 头部 - 添加玻璃态效果 */}
        <div className="sticky top-0 z-30 backdrop-blur-xl bg-white/80 border-b border-neutral-200/50">
          <Header onMenuClick={() => setMobileOpen(true)} />
        </div>

        {/* 内容区域 - 统一内边距和层次感 */}
        <main className="p-6 lg:p-8 min-h-[calc(100vh-4rem)]">
          {/* 内容容器 - 可选的统一卡片容器 */}
          <div className="max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}